module.exports = __webpack_public_path__ + "img/seen.e608d7b9.svg";